module.exports = __webpack_public_path__ + "static/media/ing.38c02b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ing.png
// module id = 1784
// module chunks = 0 1